function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, IconButton, Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import { SearchOutlinedIcon, CrossIcon } from "@tempo/icons";
import { useRef, useCallback, useState, useImperativeHandle } from "react";
export const SearchInput = forwardRef((_param, ref)=>{
    var { onChange } = _param, props = _object_without_properties(_param, [
        "onChange"
    ]);
    const inputRef = useRef(null);
    useImperativeHandle(ref, ()=>inputRef.current);
    const setInputValue = useInputSetter('value');
    const [localValue, setLocalValue] = useState('');
    const isControlled = typeof props.value === 'string';
    const value = isControlled ? props.value : localValue;
    /**
		 * Strategy: when user clicks on "clear button", we want to programmatically
		 * make the input fire a real "onChange" event with e.target.value equal to empty string
		 */ const handleClear = useCallback(()=>{
        if (inputRef.current) {
            setInputValue(inputRef.current, '');
            inputRef.current.dispatchEvent(new Event('input', {
                bubbles: true
            }));
            // After clearing the input, make the focus back to input text editing
            inputRef.current.focus();
        }
    }, [
        setInputValue
    ]);
    const handleChange = useCallback((event)=>{
        if (!isControlled) {
            setLocalValue(event.target.value);
        }
        if (onChange) {
            onChange(event);
        }
    }, [
        isControlled,
        onChange
    ]);
    return /*#__PURE__*/ _jsxs(InputGroup, {
        size: props.size,
        children: [
            /*#__PURE__*/ _jsx(InputLeftElement, {
                pointerEvents: "none",
                children: /*#__PURE__*/ _jsx(SearchOutlinedIcon, {
                    color: props.isDisabled ? 'icon.neutral.primary.disabled' : 'icon.neutral.primary.default'
                })
            }),
            /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({
                ref: inputRef,
                role: "searchbox"
            }, props), {
                onChange: handleChange
            })),
            /*#__PURE__*/ _jsx(InputRightElement, {
                children: value && !props.isDisabled && /*#__PURE__*/ _jsx(IconButton, {
                    "aria-label": "clear",
                    icon: /*#__PURE__*/ _jsx(CrossIcon, {
                        color: "icon.neutral.secondary.default"
                    }),
                    onClick: handleClear,
                    variant: "inputElement"
                })
            })
        ]
    });
});
function useInputSetter(property) {
    if (typeof window !== 'undefined') {
        const propertyDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, property);
        if (!propertyDescriptor) {
            throw new Error(`Tempo: Expected a valid HTMLInputElement's property but received: ${String(property)}`);
        }
        return (element, value)=>{
            var _propertyDescriptor_set;
            return (_propertyDescriptor_set = propertyDescriptor.set) === null || _propertyDescriptor_set === void 0 ? void 0 : _propertyDescriptor_set.call(element, value);
        };
    } else {
        return ()=>null;
    }
}

//# sourceMappingURL=SearchInput.js.map